import {Component, OnInit, HostListener, Inject} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {CookieService} from 'ngx-cookie-service';


@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  constructor(private authService: AuthenticationService, private cookieService: CookieService) {
  }

  users: any;
  username: any = '';
  customerCode: any = '';

  ngOnInit(): any {
    this.username = this.cookieService.get('user_name');
    this.customerCode = this.cookieService.get('customer_code');
  }


}
